import React from "react";

/**
 * Page-wide FAQ anchor map, keyed by `faqSlugMapKey(sectionKey, questionKey)`.
 *
 * Provided once per route so anchors are de-duplicated across *all* FAQ sections
 * on the page. A `null` value means no provider is mounted (the section-preview
 * dev harness), and consumers fall back to resolving their own section alone.
 */
const FaqAnchorContext = React.createContext<Map<string, string> | null>(null);
export function FaqAnchorProvider({
  value,
  children
}: {
  value: Map<string, string>;
  children: React.ReactNode;
}) {
  return <FaqAnchorContext.Provider value={value}>{children}</FaqAnchorContext.Provider>;
}
export function useFaqAnchors() {
  return React.useContext(FaqAnchorContext);
}